import React from 'react';
import moment from 'moment';

const CounterToBroadcast = ({ counter }) => {
    const duration = moment.duration(counter);

    const displayTimer = () => {
        const years = duration.years();
        const months = duration.months();
        const weeks = duration.weeks();
        const days = duration.days();

        const formatPlural = (val, label) => (val === '01' || val === '1') ? label : `${label}s`;

        if (years >= 1) {
            const timesLeft = duration.format('Y:M').split(':');
            const yearsLeft = timesLeft[0];
            const monthsLeft = timesLeft[1];
            return (
                <>
                    <div className="time-left-container">
                        <span className="custom-color color-1 font-size-18 time-left-value">{yearsLeft}</span>
                        <span>{formatPlural(yearsLeft, 'year')}</span>
                    </div>
                    <div className="time-left-container">
                        <span className="custom-color color-1 font-size-18 time-left-value">{monthsLeft}</span>
                        <span>{formatPlural(monthsLeft, 'month')}</span>
                    </div>
                </>
            );
        } else if (months >= 1) {
            const timesLeft = duration?.format('M:D').split(':');
            const monthsLeft = timesLeft[0];
            const daysLeft = timesLeft[1];
            return (
                <>
                    <div className="time-left-container">
                        <span className="custom-color color-1 font-size-18 time-left-value">{monthsLeft}</span>
                        <span>{formatPlural(monthsLeft, 'month')}</span>
                    </div>
                    <div className="time-left-container">
                        <span className="custom-color color-1 font-size-18 time-left-value">{daysLeft}</span>
                        <span>{formatPlural(daysLeft, 'day')}</span>
                    </div>
                </>
            );
        } else if (weeks >= 1) {
            const timesLeft = duration?.format('W:D').split(':');
            const weeksLeft = timesLeft[0];
            const daysLeft = timesLeft[1];
            return (
                <>
                    <div className="time-left-container">
                        <span className="custom-color color-1 font-size-18 time-left-value">{weeksLeft}</span>
                        <span>{formatPlural(weeksLeft, 'week')}</span>
                    </div>
                    <div className="time-left-container">
                        <span className="custom-color color-1 font-size-18 time-left-value">{daysLeft}</span>
                        <span>{formatPlural(daysLeft, 'day')}</span>
                    </div>
                </>
            );
        } else if (days >= 1) {
            const daysLeft = duration?.format('D');
            return (
                <div className="time-left-container">
                    <span className="custom-color color-1 font-size-18 time-left-value">{daysLeft}</span>
                    <span>{formatPlural(daysLeft, 'day')}</span>
                </div>
            );
        } else {
            const timesLeft = duration?.format('hh:mm:ss', { trim: false }).split(':');
            const hoursLeft = timesLeft[0];
            const minutesLeft = timesLeft[1];
            const secondsLeft = timesLeft[2];
            return (
                <>
                    <div className="time-left-container">
                        <span className="custom-color color-1 font-size-18 time-left-value">{hoursLeft}</span>
                        <span>h</span>
                    </div>
                    <div className="time-left-container">
                        <span className="custom-color color-1 font-size-18 time-left-value">{minutesLeft}</span>
                        <span>m</span>
                    </div>
                    <div className="time-left-container">
                        <span className="custom-color color-1 font-size-18 time-left-value">{secondsLeft}</span>
                        <span>s</span>
                    </div>
                </>
            );
        }
    };

    return (
        <div className="countdown-timer">
            <div className="timer-label">Live in:</div>
            {displayTimer()}
        </div>
    );
};

export default React.memo(CounterToBroadcast);

